import React from "react";

import MappingTestContext, { MappingTestContextState } from "./MappingTestContext";

// Wraps around BlueprintEditor to be able to pull global state anywhere in tree via useContext
const useMappingTestContext = (): MappingTestContextState => React.useContext(MappingTestContext);

export default useMappingTestContext;
